var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
    active: true,
    callback: _vm.onWaypoint,
    options: _vm.intersectionOptions,
  }),expression:"{\n    active: true,\n    callback: onWaypoint,\n    options: intersectionOptions,\n  }"}],staticClass:"color"})}
var staticRenderFns = []

export { render, staticRenderFns }